module.exports = __webpack_public_path__ + "media/images/home-page/1-1@2x-c280718ec8dea716a70023e94363c882.png";